module.exports = __webpack_public_path__ + "static/media/lillie-lose.f57d5d42.png";